import produce from 'immer'
import * as ActionTypes from 'actions/ActionTypes'

const initialState = {
  transcribeModels: [ ],
  fileId: null,
  fileName: null,
  taskId: null,
  status: null,
  progress: 0,
  error: null,
  result: null,
}
const setFile = (state, action) => {
  const { fileId, fileName } = action.payload
  state.fileId = fileId
  state.fileName = fileName
}

const setTranscribeModels = (state, action) => {
  const { transcribeModels } = action.payload
  state.transcribeModels = transcribeModels
}


const clearTask = state => {
  state.taskId = null
  state.status = null
  state.fileId = null
  state.fileName = null
  state.progress = 0
  state.error = null
  state.result = null
}

const updateTaskStatus = (state, action) => {
  const { taskId, status, progress, error, result } = action.payload
  if (taskId) {
    state.taskId = taskId
  }
  if (status) {
    state.status = status
  }
  if (progress !== undefined && progress !== null) {
    state.progress = progress
  }
  if (error) {
    state.error = error
  }
  if (result) {
    state.result = result
  }
}

const transcribe = (state, action) => {
  // eslint-disable-next-line default-case
  switch (action.type) {
    case ActionTypes.CLEAR_TRANSCRIBE_TASK:
      clearTask(state, action)
      break
    case ActionTypes.UPDATE_TRANSCRIBE_TASK_STATUS:
      updateTaskStatus(state, action)
      break
    case ActionTypes.SET_TRANSCRIBE_FILE:
      setFile(state, action)
      break
    case ActionTypes.SET_TRANSCRIBE_MODELS:
      setTranscribeModels(state, action)
      break
  }
}

export default produce(transcribe, initialState)
